import React from 'react'
import styled from 'styled-components'
// eslint-disable-next-line
import { Spinner } from '@pancakeswap/uikit'
import Page from '../Layout/Page'

const Wrapper = styled(Page)`
  display: flex;
  Size: 2px;
  justify-content: center;
  align-items: left;
`

const PageLoader: React.FC = () => {
  return (
    <Wrapper>
      <Spinner />
    </Wrapper>
  )
}

export default PageLoader
